var render = function render(_c,_vm){return _c('svg',{class:[_vm.data.class, _vm.data.staticClass].join(' '),attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}},[_c('path',{attrs:{"d":"M20 10a1.34 1.34 0 01-1.33 1.34h-7.33v7.33a1.34 1.34 0 01-2.67 0v-7.33H1.33a1.34 1.34 0 010-2.67h7.34V1.33a1.34 1.34 0 012.67 0v7.34h7.33A1.34 1.34 0 0120 10z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }